import { boundApiReducer as api } from 'redux-upgrader'
import * as C from './consts'

export const pushSettings = api(C.GET_PUSH_SETTINGS, Object)
